import OrderElement from './components/OrderElement';

function App() {
  return <OrderElement />;
}

export default App;
